import { Pipe, PipeTransform } from '@angular/core';

import { differenceInYears, isValid } from 'date-fns';

@Pipe({
    name: 'age'
})
export class AgePipe implements PipeTransform {
    transform(birthdate : Date) {
        if (birthdate == null || !isValid(birthdate)) return null;

        // Pull the difference in years from the birthdate and today.
        let today = new Date();

        let diff = differenceInYears(today, birthdate);

        return diff;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/age.pipe.ts